import { ValidationState } from './ValidationState';
/**
 * Validator to validate any plain-old javascript or json object (pojo).
 */
var Validator = /** @class */ (function () {
    function Validator(validating) {
        this._errors = {};
        this.validating = validating;
    }
    /**
     * Validate model.
     *
     * Returns true if their are any known validation errors for model.
     *
     * If fieldsToCheck is passed only the requested fields will be checked, however we may still return true if any errors for other
     * fields from previous calls remain even if all the fields checked this call passed all validation.
     * @param model model to validate.
     * @param fieldsToCheck if passed only the listed fields will be checked.
     */
    Validator.prototype.validate = function (model, fieldsToCheck) {
        var builder = new ValidationState(this._errors);
        this.validating(model, builder, fieldsToCheck);
        return !this.hasErrors();
    };
    /**
     * Returns the errors found by the validator.
     */
    Validator.prototype.errors = function () {
        return this._errors;
    };
    /**
     * Returns the errors found by the validator for fieldName.
     */
    Validator.prototype.errorsFor = function (fieldName) {
        return this._errors[fieldName] || [];
    };
    /**
     *Returns true if this validator has any errors for any fields.
     */
    Validator.prototype.hasErrors = function () {
        var keys = Object.keys(this._errors);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (this._errors[key].length) {
                return true;
            }
        }
        return false;
    };
    return Validator;
}());
export { Validator };
//# sourceMappingURL=Validator.js.map